/* Monte seu Kit — montador de kit de cultivo (estufa > LED > exaustor > filtro) */
(function () {
  'use strict';

  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
  var LOCALE = (window.Shopify && window.Shopify.locale) || 'pt-BR';

  function money(cents) {
    try {
      return new Intl.NumberFormat(LOCALE, { style: 'currency', currency: CURRENCY }).format(cents / 100);
    } catch (e) {
      return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
    }
  }

  /* ---------- rastreamento ----------
     Dispara o mesmo evento em todos os canais que existirem na página:
     o barramento oficial do Shopify (que os pixels personalizados escutam),
     o dataLayer/gtag do GA4 e o fbq do Meta. Cada um é isolado num try
     para que um canal ausente nunca quebre o montador. */
  function track(evento, dados) {
    dados = dados || {};
    try {
      if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) {
        window.Shopify.analytics.publish(evento, dados);
      }
    } catch (e) {}
    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: evento }, dados));
      }
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') window.gtag('event', evento, dados);
    } catch (e) {}
    try {
      if (typeof window.fbq === 'function') window.fbq('trackCustom', evento, dados);
    } catch (e) {}
  }

  // de onde o cliente veio: ?de=header, ?de=aba, ?de=menu — guardado na sessão
  // porque a URL é reescrita conforme ele monta o kit
  function descobrirOrigem() {
    var origem = 'direto';
    try {
      var p = new URLSearchParams(window.location.search).get('de');
      if (p) {
        origem = p.slice(0, 20);
        sessionStorage.setItem('mpkb_origem', origem);
      } else {
        origem = sessionStorage.getItem('mpkb_origem') || 'direto';
      }
    } catch (e) {}
    return origem;
  }

  function KitBuilder(root) {
    this.root = root;
    this.hasFilterStep = root.dataset.filterStep === 'true';
    this.totalSteps = parseInt(root.dataset.totalSteps, 10) || 4;
    this.addUrl = root.dataset.cartAddUrl || '/cart/add.js';
    this.updateUrl = root.dataset.cartUpdateUrl || '/cart/update.js';
    this.cartUrl = root.dataset.cartUrl || '/cart';
    this.origem = descobrirOrigem();
    this.cupomKit = (root.dataset.kitDiscountCode || '').trim();
    // sem cupom configurado não existe desconto de kit: o percentual só pode
    // entrar na conta quando há um código para aplicar, senão a barra prometeria
    // um abatimento que o carrinho não vai dar
    this.pctKit = this.cupomKit ? parseFloat(root.dataset.kitDiscountPercent) || 0 : 0;

    this.navItems = Array.prototype.slice.call(root.querySelectorAll('[data-go]'));
    this.steps = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    this.bar = root.querySelector('[data-mpkb-bar]');
    this.chips = root.querySelector('[data-mpkb-chips]');
    this.totalEl = root.querySelector('[data-mpkb-total]');
    this.addBtn = root.querySelector('[data-mpkb-add]');
    this.errorEl = root.querySelector('[data-mpkb-error]');
    this.ownInput = root.querySelector('[data-mpkb-own]');
    this.noFilterInput = root.querySelector('[data-mpkb-nofilter]');
    this.filterHint = root.querySelector('[data-mpkb-filter-hint]');

    this.state = { step: 1, size: null, tent: null, includeTent: true, led: null, fan: null, filter: null, noFilter: false };

    this.bind();
    this.restoreFromUrl();
    this.render();

    track('monte_seu_kit_abrir', { origem: this.origem });
  }

  KitBuilder.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (event) {
      var sizeBtn = event.target.closest('[data-mpkb-size]');
      if (sizeBtn && self.root.contains(sizeBtn)) {
        self.pickSize(sizeBtn);
        return;
      }

      var option = event.target.closest('[data-mpkb-option]');
      if (option && !option.disabled) {
        self.pickOption(option);
        return;
      }

      var next = event.target.closest('[data-mpkb-next]');
      if (next) {
        self.go(self.state.step + 1);
        return;
      }

      var back = event.target.closest('[data-mpkb-back]');
      if (back) {
        self.go(self.state.step - 1);
        return;
      }

      var nav = event.target.closest('[data-go]');
      if (nav && (nav.classList.contains('is-done') || nav.classList.contains('is-current'))) {
        self.go(parseInt(nav.dataset.go, 10));
        return;
      }

      if (event.target.closest('[data-mpkb-add]')) {
        self.addToCart();
      }
    });

    if (this.ownInput) {
      this.ownInput.addEventListener('change', function () {
        self.state.includeTent = !this.checked;
        self.render();
      });
    }

    if (this.noFilterInput) {
      this.noFilterInput.addEventListener('change', function () {
        self.state.noFilter = this.checked;
        if (this.checked) self.state.filter = null;
        self.render();
      });
    }
  };

  /* ---------- seleção ---------- */

  KitBuilder.prototype.pickSize = function (btn) {
    var changed = this.state.size !== btn.dataset.mpkbSize;
    this.state.size = btn.dataset.mpkbSize;
    this.state.label = btn.dataset.label || '';
    this.state.tent = {
      vid: btn.dataset.tentVid,
      price: parseInt(btn.dataset.tentPrice, 10) || 0,
      compare: parseInt(btn.dataset.tentCompare, 10) || 0,
      title: btn.dataset.tentTitle || '',
      available: btn.dataset.tentAvailable === '1',
      qty: 1
    };

    if (!this.state.tent.available || !this.state.tent.vid) {
      this.state.includeTent = false;
      if (this.ownInput) {
        this.ownInput.checked = true;
      }
    }

    if (changed) {
      this.state.led = null;
      this.state.fan = null;
      this.state.filter = null;
    }

    if (!this.restoring) {
      track('monte_seu_kit_passo', { passo: 1, etapa: 'estufa', escolha: this.state.label });
    }

    this.render();
    this.go(2);
  };

  KitBuilder.prototype.pickOption = function (btn) {
    var item = {
      vid: btn.dataset.vid,
      price: parseInt(btn.dataset.price, 10) || 0,
      compare: parseInt(btn.dataset.compare, 10) || 0,
      qty: parseInt(btn.dataset.qty, 10) || 1,
      title: btn.dataset.title || '',
      duct: btn.dataset.duct || ''
    };

    if (!this.restoring) {
      var etapas = { led: { passo: 2, nome: 'led' }, fan: { passo: 3, nome: 'exaustor' }, filter: { passo: 4, nome: 'filtro' } };
      var e = etapas[btn.dataset.kind];
      if (e) {
        track('monte_seu_kit_passo', {
          passo: e.passo,
          etapa: e.nome,
          escolha: item.title,
          estufa: this.state.label || ''
        });
      }
    }

    if (btn.dataset.kind === 'led') {
      this.state.led = item;
      this.render();
      this.go(3);
    } else if (btn.dataset.kind === 'fan') {
      var ductChanged = !this.state.fan || this.state.fan.duct !== item.duct;
      this.state.fan = item;
      if (ductChanged) this.state.filter = null;
      this.render();
      this.go(this.hasFilterStep ? 4 : 3);
    } else if (btn.dataset.kind === 'filter') {
      this.state.filter = item;
      this.state.noFilter = false;
      if (this.noFilterInput) this.noFilterInput.checked = false;
      this.render();
    }
  };

  /* ---------- navegação ---------- */

  KitBuilder.prototype.go = function (step) {
    if (step < 1) step = 1;
    if (step > this.totalSteps) step = this.totalSteps;
    if (step > 1 && !this.state.size) step = 1;
    if (step > 2 && !this.state.led) step = 2;
    if (step > 3 && !this.state.fan) step = 3;

    this.state.step = step;
    this.render();

    if (this.restoring) return;

    var el = this.root.querySelector('[data-step="' + step + '"]');
    if (el) {
      var top = el.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  };

  /* ---------- render ---------- */

  KitBuilder.prototype.render = function () {
    var self = this;
    var s = this.state;

    this.steps.forEach(function (el) {
      el.hidden = parseInt(el.dataset.step, 10) !== s.step;
    });

    this.navItems.forEach(function (el) {
      var n = parseInt(el.dataset.go, 10);
      el.classList.toggle('is-current', n === s.step);
      el.classList.toggle('is-done', n < s.step);
    });

    // painéis do tamanho escolhido
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-pane-for]'), function (pane) {
      pane.hidden = pane.dataset.paneFor !== s.size;
    });

    // marca selecionados
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-mpkb-size]'), function (el) {
      var on = el.dataset.mpkbSize === s.size;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    Array.prototype.forEach.call(this.root.querySelectorAll('[data-mpkb-option]'), function (el) {
      var kind = el.dataset.kind;
      var chosen = s[kind === 'fan' ? 'fan' : kind === 'led' ? 'led' : 'filter'];
      var on = !!chosen && chosen.vid === el.dataset.vid;
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // filtros compatíveis com o diâmetro do exaustor escolhido
    if (this.hasFilterStep) {
      var duct = s.fan ? s.fan.duct : '';
      var visible = 0;
      Array.prototype.forEach.call(this.root.querySelectorAll('[data-pane-step="4"] [data-mpkb-option]'), function (el) {
        var ok = !duct || !el.dataset.duct || el.dataset.duct === duct;
        el.hidden = !ok;
        if (ok) visible++;
      });
      if (this.filterHint && duct) {
        this.filterHint.textContent = visible
          ? 'Mostrando só os filtros de ' + duct + 'mm, o mesmo diâmetro do exaustor que você escolheu.'
          : 'Não temos filtro de ' + duct + 'mm disponível agora. Você pode seguir sem filtro e adicionar depois.';
      }
    }

    // botões continuar
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-mpkb-next]'), function (btn) {
      var step = parseInt(btn.closest('[data-step]').dataset.step, 10);
      var ok = (step === 1 && s.size) || (step === 2 && s.led) || (step === 3 && s.fan);
      btn.disabled = !ok;
    });

    // rótulo do tamanho nos títulos
    Array.prototype.forEach.call(this.root.querySelectorAll('[data-mpkb-echo-size]'), function (el) {
      el.textContent = s.label ? s.label : '';
    });

    this.renderBar();
    this.syncUrl();
  };

  KitBuilder.prototype.lineItems = function () {
    var s = this.state;
    var items = [];
    function push(o, qty) {
      items.push({ id: o.vid, quantity: qty, price: o.price, compare: o.compare || 0, title: o.title });
    }
    if (s.includeTent && s.tent && s.tent.vid && s.tent.available) push(s.tent, 1);
    if (s.led) push(s.led, s.led.qty);
    if (s.fan) push(s.fan, s.fan.qty);
    if (s.filter && !s.noFilter) push(s.filter, s.filter.qty);
    return items;
  };

  KitBuilder.prototype.renderBar = function () {
    var items = this.lineItems();

    if (!this.bar) return;
    this.bar.hidden = items.length === 0;

    // mesma regra do resto do site: destaque no à vista (-5%), "de" riscado e 10x sobre o cheio
    var total = items.reduce(function (sum, i) {
      return sum + i.price;
    }, 0);
    var totalCompare = items.reduce(function (sum, i) {
      return sum + (i.compare > i.price ? i.compare : i.price);
    }, 0);
    // com o cupom do kit já descontado — é este o valor que vai para o carrinho
    var comKit = Math.round(total * (1 - this.pctKit / 100));
    /*
     * O Pix incide sobre o subtotal, e o subtotal depende do TIPO do cupom:
     * - cupom de PRODUTO (o caso de hoje): desconta linha a linha, então o subtotal
     *   já vem abatido e o Pix compõe em cima -> 0,95 x 0,95 = 9,75% no total;
     * - cupom de PEDIDO: não mexe no subtotal, e os dois 5% somam -> 10% cheios.
     * Medido no checkout em 2026-10-08 com o cupom de produto: R$ 855,32 de catálogo
     * fecharam em R$ 771,95. Se o cupom voltar a ser de pedido, isto aqui muda.
     */
    var avista = Math.round(comKit * 0.95);

    if (this.totalEl) this.totalEl.textContent = items.length ? money(avista) : '—';

    var wasEl = this.root.querySelector('[data-mpkb-total-was]');
    if (wasEl) {
      wasEl.hidden = !items.length || totalCompare <= avista;
      wasEl.textContent = money(totalCompare);
    }

    var instEl = this.root.querySelector('[data-mpkb-inst]');
    if (instEl) {
      instEl.innerHTML = items.length
        ? 'À vista, ou <b>10x</b> de <b>' + money(comKit / 10) + '</b> sem juros'
        : '';
    }

    var countEl = this.root.querySelector('[data-mpkb-count]');
    if (countEl) {
      countEl.textContent = items.length ? ' · ' + items.length + (items.length > 1 ? ' itens' : ' item') : '';
    }

    if (this.chips) {
      this.chips.innerHTML = '';
      items.forEach(function (i) {
        var li = document.createElement('li');
        var b = document.createElement('b');
        b.textContent = i.title;
        li.appendChild(b);
        if (i.quantity > 1) {
          var q = document.createElement('span');
          q.textContent = '×' + i.quantity;
          li.appendChild(q);
        }
        this.chips.appendChild(li);
      }, this);
    }

    // só libera o botão com LED e exaustor definidos
    if (this.addBtn) {
      this.addBtn.disabled = !(this.state.led && this.state.fan);
    }
  };

  /* ---------- URL compartilhável ---------- */

  KitBuilder.prototype.syncUrl = function () {
    var s = this.state;
    if (!s.size) return;
    var p = new URLSearchParams();
    p.set('t', s.size);
    if (s.led) p.set('led', s.led.vid);
    if (s.fan) p.set('exa', s.fan.vid);
    if (s.filter) p.set('flt', s.filter.vid);
    if (!s.includeTent) p.set('semestufa', '1');
    try {
      window.history.replaceState({}, '', window.location.pathname + '?' + p.toString());
    } catch (e) {
      /* silencioso */
    }
  };

  KitBuilder.prototype.restoreFromUrl = function () {
    var p = new URLSearchParams(window.location.search);
    var size = p.get('t');
    if (!size) return;

    var sizeBtn = this.root.querySelector('[data-mpkb-size="' + size + '"]');
    if (!sizeBtn) return;

    this.restoring = true;
    this.pickSize(sizeBtn);
    if (p.get('semestufa') === '1' && this.ownInput) {
      this.ownInput.checked = true;
      this.state.includeTent = false;
    }

    var self = this;
    [['led', 'led'], ['exa', 'fan'], ['flt', 'filter']].forEach(function (pair) {
      var vid = p.get(pair[0]);
      if (!vid) return;
      var btn = self.root.querySelector('[data-pane-for="' + size + '"] [data-mpkb-option][data-vid="' + vid + '"]');
      if (btn && !btn.disabled) self.pickOption(btn);
    });

    this.restoring = false;
  };

  /* ---------- carrinho ---------- */

  /*
   * Aplica o cupom do kit pelo carrinho AJAX ({discount: "CODIGO"} no /cart/update).
   *
   * Duas regras deliberadas:
   * - se o cliente já tem um cupom válido, não trocamos por cima. O campo `discount`
   *   do Shopify SUBSTITUI o anterior, e trocar o cupom dele em silêncio poderia
   *   rebaixar um desconto melhor que o nosso;
   * - se a loja recusar o código (não existe, expirou, não bateu a condição), limpamos
   *   para o carrinho não ficar segurando um cupom inválido.
   * Em qualquer erro a compra segue: desconto não pode derrubar venda.
   */
  KitBuilder.prototype.aplicarCupomDoKit = function (carrinho) {
    var self = this;
    if (!this.cupomKit) return Promise.resolve();

    var jaTemCupom =
      carrinho &&
      (carrinho.discount_codes || []).some(function (d) {
        return d.applicable;
      });

    if (jaTemCupom) {
      track('monte_seu_kit_cupom', { resultado: 'cliente_ja_tinha_cupom', origem: this.origem });
      return Promise.resolve();
    }

    function mandar(codigo) {
      return fetch(self.updateUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: codigo })
      }).then(function (r) {
        return r.json();
      });
    }

    return mandar(this.cupomKit)
      .then(function (c) {
        var aceito = (c.discount_codes || []).some(function (d) {
          return d.applicable && d.code.toLowerCase() === self.cupomKit.toLowerCase();
        });

        track('monte_seu_kit_cupom', {
          resultado: aceito ? 'aplicado' : 'recusado',
          codigo: self.cupomKit,
          origem: self.origem
        });

        if (!aceito) return mandar('');
      })
      .catch(function () {});
  };

  KitBuilder.prototype.addToCart = function () {
    var self = this;
    var linhas = this.lineItems();
    var estufa = this.state.label || '';

    // Mesma marcação dos brindes (snippets/brindes.liquid): uma propriedade de linha
    // por item, com underscore para esconder do cliente e continuar visível no pedido.
    // O tamanho da estufa não se repete aqui — vai uma vez só nos atributos do carrinho.
    var items = linhas.map(function (i) {
      return {
        id: i.id,
        quantity: i.quantity,
        properties: { _kit: 'monte-seu-kit' }
      };
    });

    if (!items.length) return;

    var total = linhas.reduce(function (s, i) {
      return s + i.price;
    }, 0);

    this.addBtn.disabled = true;
    this.addBtn.classList.add('loading');
    var spinner = this.addBtn.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');
    if (this.errorEl) this.errorEl.hidden = true;

    fetch(this.addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Não foi possível adicionar o kit.');
          return data;
        });
      })
      .then(function () {
        // dispara antes da próxima chamada de rede: assim o evento tem a ida e volta
        // dela para escoar, em vez de disputar com o redirecionamento para o carrinho
        track('monte_seu_kit_adicionar', {
          origem: self.origem,
          estufa: estufa,
          itens: items.length,
          valor: Math.round(total * (1 - self.pctKit / 100)) / 100,
          moeda: CURRENCY
        });

        // atributos do carrinho: marcam a origem do pedido e sobrevivem até o admin.
        // Se falhar, seguimos assim mesmo — não vale travar a compra por causa da etiqueta.
        return fetch(self.updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            attributes: {
              monte_seu_kit: 'sim',
              monte_seu_kit_estufa: estufa,
              monte_seu_kit_origem: self.origem
            }
          })
        })
          .then(function (r) {
            return r.json();
          })
          .catch(function () {
            return null;
          });
      })
      .then(function (carrinho) {
        return self.aplicarCupomDoKit(carrinho);
      })
      .then(function () {
        window.location = self.cartUrl;
      })
      .catch(function (err) {
        self.addBtn.disabled = false;
        self.addBtn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
        if (self.errorEl) {
          self.errorEl.hidden = false;
          self.errorEl.textContent = err.message + ' Tente novamente ou fale com a gente no WhatsApp.';
        }
      });
  };

  function init() {
    // na própria página do montador a aba lateral não faz sentido
    // (o :has() do CSS já cobre, isto é a rede de segurança para navegadores antigos)
    if (document.querySelector('[data-mpkb]')) {
      Array.prototype.forEach.call(document.querySelectorAll('.mpkb-tab'), function (tab) {
        tab.classList.add('is-hidden');
      });
    }

    Array.prototype.forEach.call(document.querySelectorAll('[data-mpkb]'), function (root) {
      if (!root.dataset.mpkbReady) {
        root.dataset.mpkbReady = '1';
        new KitBuilder(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // recria ao editar no editor de temas
  document.addEventListener('shopify:section:load', init);
})();
